{
  "name": "@testim/testim-cli",
  "version": "4.187.4",
  "description": "Command line interface for running Testing on your CI",
  "author": "Oren Rubin",
  "contributors": [
    {
      "name": "Oren Rubin",
      "email": "oren@testim.io"
    }
  ],
  "bugs": {
    "email": "info@testim.io"
  },
  "devDependencies": {
    "@bcoe/v8-coverage": "0.2.3",
    "@types/agent-base": "4.2.2",
    "app-root-dir": "1.0.2",
    "@types/app-root-dir": "0.1.0",
    "@types/body-parser": "1.19.6",
    "@types/compression": "1.7.0",
    "@types/chai-string": "1.4.2",
    "@types/cors": "2.8.19",
    "@types/debug": "4.1.12",
    "@types/execa": "2.0.0",
    "@types/express": "4.17.21",
    "@types/form-data": "2.5.0",
    "@wdio/protocols": "8.44.0",
    "execa": "5.0.0",
    "source-map": "0.7.4",
    "v8-to-istanbul": "9.1.0",
    "@types/istanbul-lib-coverage": "2.0.6",
    "@types/istanbul-lib-report": "3.0.3",
    "@types/istanbul-reports": "3.0.4",
    "@types/lodash": "4.17.21",
    "@types/memory-fs": "0.3.3",
    "@types/ms": "0.7.31",
    "@types/multer": "1.4.4",
    "@types/node": "22.15.17",
    "@types/node-fetch": "2.6.12",
    "@types/object-hash": "2.2.1",
    "@types/pako": "1.0.3",
    "@types/proxyquire": "1.3.28",
    "@types/promise-queue": "2.2.0",
    "@types/prompts": "2.4.2",
    "@types/rox-node": "5.0.5",
    "@types/selenium-webdriver": "4.0.9",
    "@types/semver": "7.5.8",
    "@types/sinon": "9.0.4",
    "@types/sinon-chai": "3.2.10",
    "@types/source-map": "0.5.7",
    "@types/superagent": "8.1.9",
    "@types/superagent-proxy": "3.0.4",
    "@types/test-exclude": "6.0.0",
    "@types/ua-parser-js": "0.7.39",
    "@types/validate-npm-package-name": "3.0.3",
    "@wdio/types": "9.16.2",
    "@types/ws": "8.18.1",
    "@types/xml2js": "0.4.14",
    "bundle-deps": "1.0.0",
    "chai-shallow-deep-equal": "1.4.6",
    "chai-string": "1.3.0",
    "esbuild": "0.27.2",
    "glob": "11.1.0",
    "proxyquire": "2.1.3",
    "sinon": "19.0.2",
    "sinon-chai": "3.7.0",
    "ts-node": "10.9.2",
    "tsconfig-paths": "3.12.0"
  },
  "lazyDependencies": {
    "v8-to-istanbul": "9.1.0",
    "istanbul-lib-coverage": "3.2.0",
    "@bcoe/v8-coverage": "0.2.3",
    "convert-source-map": "1.7.0",
    "multer": "2.1.1"
  },
  "dependencies": {
    "@applitools/eyes-sdk-core": "13.11.34-legacy.1",
    "@testim/shared-logger": "workspace:*",
    "@applitools/spec-driver-webdriverio": "1.4.29",
    "@segment/analytics-node": "2.1.3",
    "@types/unzip-stream": "0.3.4",
    "ajv": "6.12.6",
    "body-parser": "1.20.4",
    "chalk": "4.1.2",
    "chrome-launcher": "0.15.0",
    "commander": "10.0.0",
    "compression": "1.8.1",
    "cors": "2.8.5",
    "data-uri-to-buffer": "2.0.2",
    "dayjs": "1.11.8",
    "eventsource": "3.0.6",
    "form-data": "^4.0.4",
    "express": "4.22.1",
    "fkill": "7.2.1",
    "https-proxy-agent": "7.0.2",
    "istanbul-lib-report": "3.0.0",
    "istanbul-reports": "3.1.5",
    "jsonwebtoken": "9.0.3",
    "linkedom": "0.18.0",
    "lodash": "4.17.23",
    "memory-fs": "0.5.0",
    "ms": "2.1.2",
    "node-fetch": "2.7.0",
    "object-hash": "3.0.0",
    "ora": "5.4.1",
    "p-limit": "4.0.0",
    "p-retry": "4.6.2",
    "pako": "1.0.11",
    "portfinder": "1.0.28",
    "promise-queue": "2.2.5",
    "prompts": "2.4.2",
    "proxy-agent": "6.3.1",
    "rox-node": "5.4.12",
    "semver": "7.6.0",
    "serialize-error": "7.0.1",
    "socket.io-client": "4.8.0",
    "source-map-support": "0.5.19",
    "superagent": "9.0.1",
    "superagent-proxy": "3.0.0",
    "test-exclude": "7.0.0",
    "ua-parser-js": "0.7.39",
    "unzip-stream": "0.3.4",
    "uuid": "11.0.5",
    "validate-npm-package-name": "3.0.0",
    "webdriverio": "9.18.4",
    "winston": "3.11.0",
    "winston-transport": "4.6.0",
    "ws": "8.17.1",
    "xml2js": "0.6.2",
    "yaml": "2.2.2"
  },
  "peerDependencies": {
    "vitest": "*"
  },
  "license": "Proprietary",
  "bin": {
    "testim": "cli.js"
  },
  "scripts": {
    "start": "NODE_OPTIONS=--no-experimental-strip-types ts-node-transpile-only ./src/cli",
    "dev": "NODE_OPTIONS=--no-experimental-strip-types ts-node --transpile-only=false ./src/cli",
    "test": "pnpm test:vitest && pnpm test:mocha",
    "test:mocha": "pnpm test:pattern './src/**/*.test.[jt]s'",
    "test:vitest": "vitest",
    "test:pattern": "NODE_OPTIONS=--no-experimental-strip-types IS_UNIT_TEST=1 ../../node_modules/mocha/bin/_mocha --timeout 2000 --exit --recursive --watch-files 'src' -r ts-node/register/transpile-only -r tsconfig-paths/register --reporter mocha-multi-reporters --reporter-options configFile=mochaReporterConfig.js",
    "test:cov": "nyc --reporter=lcov --reporter=text pnpm test",
    "prepare-version": "rm -rf ./deploy && mkdir -p deploy && tsx buildTool prepare-version-on-prem",
    "self-test": "cd /tmp && DEBUG=self-test BUILD_MAX_MEMORY=4096 tsx $(echo $GITHUB_WORKSPACE)/apps/runner/scripts/selfTest.ts",
    "type-check": "node ../../scripts/type-check.mjs tsconfig.json",
    "deploy": "timeout 1800 pnpm tsx ./scripts/deploy"
  },
  "engines": {
    "node": ">= 18.0.0"
  },
  "overrides": {
    "xml2js": "0.6.2",
    "node-fetch": "2.7.0",
    "http-cache-semantics": "4.1.1",
    "tough-cookie": "4.1.3",
    "degenerator": "5.0.1",
    "semver": "7.6.0",
    "pac-resolver": "7.0.1",
    "fastify": "5.7.2"
  }
}